import axios from 'axios';

const api = '/api/payment-frequencies';

export const getAllPaymentFrequencies = () => {
  return axios.get(`${api}?cacheBuster=${new Date().getTime()}`);
};
